<template>
  <app-modal name="get-template-modal" :title="title" @before-open="beforeOpen" @before-close="beforeClose"
    @on-ok="populateProductsFromTemplate" :ok-text="$t('app.save')" :is-submitting="isLoading"
    :cancel-text="$t('actions.options.CANCEL_INVOICE')" width="50%">
    <app-search-box :placeholder="$t('app.search')" :value="searchText" :debounce="500" @search="onChangeSearchText"
      class="mb-3" size="lg"></app-search-box>
    <h5 class="mb-3">{{ $t("app.incomingInvoiceList") }}</h5>
    <app-table :fields="fields" :filter="false" :api-mode="false" :pagination="false" :hide-header="true"
      row-class="transparent cursor-pointer" :css="{ tableClass: 'vuetable table border border-primary rounded-lg' }"
      :data="invoiceList">
      <div slot="checkbox" slot-scope="props">
        <input type="checkbox" :checked="selectedInvoices.has(props.rowData.id)" @change="evt => {
          evt.target.checked = !evt.target.checked
          onSelectInvoice(props.rowData)
        }" />
      </div>
      <div slot="seller_info" slot-scope="props">
        <span class='font-weight-bold'>{{ props.rowData.invoice_number }}</span>
        <br />
        <span>{{ props.rowData.seller_name }}</span>
      </div>
      <div slot="eye" slot-scope="props" @click="onViewInvoice($event, props.rowData)">
        <app-icon name="eye" size="20" type="fill" />
      </div>
    </app-table>
    <div class="my-3 d-flex flex-lg-row flex-col justify-content-end align-items-center">
      <b-pagination v-model="invoiceListPageInfo.current_page" :page="invoiceListPageInfo.current_page"
        :total-rows="invoiceListPageInfo.total" :per-page="invoiceListPageInfo.current_limit" first-number last-number
        @page-click="onPageClick" size="sm"></b-pagination>
    </div>
    <h5 class="mb-3">{{ $t("app.chosenInvoiceList") }} ({{ selectedInvoicesArray.length }})</h5>
    <app-table :fields="chosenInvoiceTableFields" :filter="false" :api-mode="false" :hide-header="true"
      :pagination="false" :data="selectedInvoicesArray.length > 0 ? selectedInvoicesArray : []">
      <div slot="crossmark" slot-scope="props">
        <span @click="onRemoveInvoice(props.rowData)">
          <app-icon name="times" size="16" type="fill" />
        </span>
      </div>
      <div slot="seller_info" slot-scope="props">
        <span class='font-weight-bold'>{{ props.rowData.invoice_number }}</span>
        <br />
        <span>{{ props.rowData.seller_name }}</span>
      </div>
    </app-table>
  </app-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import NumericUtils from '@/utils/numeric';
// import ToastUtils from '@/utils/toast';
import AppSearchBox from '@/components/app-search-box';
import AppModal from '@/components/app-modal/';
import AppTable from '@/components/app-table/';
import AppIcon from '@/components/app-icon/';
import { mapState } from 'vuex/dist/vuex.common.js';
import { calculateTotalsFromInvoice } from '../../utils/invoice';


function customReviver(key, value) {
  if (typeof value === 'string') {
    // Convert number-like strings to numbers
    if (!isNaN(value) && value.trim() !== '') {
      return parseFloat(value);
    }

    // Convert VAT rate like "8%" → 8
    const percentMatch = value.match(/^(\d+(?:\.\d+)?)%$/);
    if (percentMatch) {
      return parseFloat(percentMatch[1]);
    }
  }
  return value;
}

export default {
  name: 'GetTemplateModal',
  // mixins: [AppBasePageMixins],
  components: {
    AppModal,
    AppTable,
    AppSearchBox,
    AppIcon
  },

  data() {
    return {
      isMobile: false,
      title: "Lấy mẫu hóa đơn đầu vào",
      isLoading: false,
      fields: [
        {
          name: '__slot:checkbox',
          width: '10%',
        },
        {
          name: '__slot:seller_info',
          title: 'reconciliation.legalName',
          dataClass: 'border-bottom rounded-0 w-50',
          width: '75%',
        },
        {
          name: 'total_amount_with_tax',
          title: 'invoice.total_amount_with_tax',
          dataClass: 'align-bottom border-bottom text-right rounded-0',
          type: 'currency',
          callback: value => NumericUtils.formatAmount(value),
          width: '5%',
        },
        {
          name: '__slot:eye',
          dataClass: 'text-sm-center align-bottom',
          width: '10%'
          // title: 'app.action',
        },
      ],
      chosenInvoiceTableFields: [
        {
          name: '__slot:crossmark',
          dataClass: 'text-center'
        },
        {
          name: '__slot:seller_info',
          title: 'reconciliation.legalName',
        },
        {
          name: 'total_amount_with_tax',
          title: 'invoice.total_amount_with_tax',
          type: 'currency',
          callback: value => NumericUtils.formatAmount(value)
          // formatFn: value => NumericUtils.formatAmount(value),
        },
      ],
      selectedInvoices: new Map(),
      page: 1,
      searchText: '',
      key: Math.random()
    };
  },
  computed: {
    ...mapState([
      'invoiceGlobalSearchParams',
      'invoiceList',
      'invoiceListLoading',
      'invoiceListPageInfo'
    ]),
    selectedInvoicesArray() {
      return this.selectedInvoices.size ? [...this.selectedInvoices.values()] : []
    },
  },
  methods: {
    ...mapActions(['getInvoices', 'setState']),
    beforeClose() {
      this.searchText = ''
      this.selectedInvoices = new Map()
      this.isLoading = false
    },
    initialize() {
      this.isLoading = false;
    },
    onViewInvoice(event, rowData) {
      this.$modal.show('invoice-viewer-modal', {
        model: rowData
      });
    },
    fetchInvoices(searchText, page = 1) {
      let params = {
        is_secure: true,
        origin: this.invoiceGlobalSearchParams.origin || ['1', '3', '4'],
        invoice_outgoing: false,
        period: this.invoiceGlobalSearchParams.period,
        currency: this.invoiceGlobalSearchParams.currency,
        invoiceType: 'INCOMING',
        page_size: 5
      }

      if (searchText && searchText.length) {
        delete params.page
        params.search_text = searchText
        // params.search_text = searchText
      } else {
        params = {
          ...params,
          page: this.page,
          exclude_invoice_types: '[DRAFT]'
        }
      };
      return this.getInvoices(params)
    },
    beforeOpen(params) {
      this.fetchInvoices()
      // .then(res => setState({ invoiceViewerData: res.data, invoiceViewerLoading: false }));
    },
    onChangeSearchText(text) {
      this.fetchInvoices(text)
    },
    onSelectInvoice(invoice) {
      if (this.selectedInvoices.has(invoice.id)) {
        this.selectedInvoices.delete(invoice.id);
      } else {
        this.selectedInvoices.set(invoice.id, {
          id: invoice.id,
          invoice_number: invoice.invoice_number,
          seller_name: invoice.seller_name,
          total_amount_with_tax: invoice.total_amount_with_tax,
          products: invoice.content
        })
      }
      this.selectedInvoices = new Map(this.selectedInvoices)
    },
    onPageClick(event, page) {
      this.page = page
      this.fetchInvoices(this.searchText, page)
    },
    onRemoveInvoice(invoice) {
      this.selectedInvoices.delete(invoice.id)
      this.selectedInvoices = new Map(this.selectedInvoices)
    },
    populateProductsFromTemplate() {
      let products = []
      this.isLoading = true;

      setTimeout(() => {
        this.$modal.hide('get-template-modal', { isOk: true })
        this.isLoading = false;
      }, 1000)

      const totals = {
        total_amount_with_tax: 0,
        total_tax_mount: 0,
        total_amount_without_tax: 0
      }

      this.selectedInvoicesArray.forEach(invoice => {
        invoice.products = invoice.products.replace(/'/g, '"');
        const parsedProductSubList = JSON.parse(invoice.products, customReviver)
        const { total_amount_with_tax, total_tax_mount, total_amount_without_tax } = calculateTotalsFromInvoice(parsedProductSubList)
        totals.total_amount_with_tax += total_amount_with_tax
        totals.total_tax_mount += total_tax_mount
        totals.total_amount_without_tax += total_amount_without_tax
        products = products.concat(parsedProductSubList)
      })
      this.$bus.emit('autofill-products-from-template', JSON.stringify(products), totals)
    }
  },
  watch: {
    invoiceListLoading(val) {
      if (!val) {
        this.key = Math.random()
      }
    }
  }
};
</script>
<style lang="scss" scoped>
h5 {
  color: #0078D4;
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/get-template-modal.vue